import server from "@/src/api/server";
import "bootstrap/dist/css/bootstrap.css";
import Script from "next/script";
import { Col, Row } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import Form from "@/src/components/Shared/Form";
import styles from "@/styles/contact.module.scss";
import { checkRedirect } from "@/src/components/helpers/functions";
import HeroSection from "@/src/components/Home/HeroSection";
import About from "@/src/components/Home/About";
import Systems from "@/src/components/Home/Systems";
import Countries from "@/src/components/Home/Countries";
import Seo from "@/src/components/Shared/Next-seo";
import RequirementsSection from "@/src/components/Home/RequirementsSection";

const Index = (props) => {
  const {
    heroData,
    systemsData,
    aboutData,
    countriesData,
    personnelsData,
    requirementsData,
    siteInfo,
    initData,
    seoData,
  } = props;
  const { locale } = useIntl();

  return (
    <>
      <Seo
        title={seoData?.title?.[locale]}
        description={seoData?.description?.[locale]}
        keywords={seoData?.keywords?.[locale]}
      />

      <Script
        id="ld-json-organization"
        type="application/ld+json"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Organization",
                "@id": "https://alnjoom.sa/#organization",
                name: "مكتب النجوم المميزة للاستقدام في تبوك",
                alternateName: "Al Nojoom Al Mumayazah Recruitment Office",
                url: "https://alnjoom.sa/",
                logo: {
                  "@type": "ImageObject",
                  "@id": "https://alnjoom.sa/#logo",
                  url: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png",
                  contentUrl:
                    "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png",
                  caption: "مكتب النجوم المميزة للاستقدام",
                },
                image: {
                  "@type": "ImageObject",
                  url: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png",
                },
                telephone: "+966594003605",
                email: "ads@alnjoom.sa",
                foundingDate: "2010-01-01",
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "King Fahd Rd, Assulimaniyah",
                  addressLocality: "Tabuk",
                  addressRegion: "Tabuk",
                  postalCode: "47312",
                  addressCountry: "SA",
                },
                contactPoint: {
                  "@type": "ContactPoint",
                  "@id": "https://alnjoom.sa/#contact",
                  telephone: "+966594003605",
                  contactType: "customer support",
                  availableLanguage: ["Arabic", "English"],
                  areaServed: "SA",
                },
                sameAs: [
                  "https://twitter.com/alnjoom33",
                  "https://www.tiktok.com/@alnjoom33",
                  "https://snapchat.com/t/OqgbB9dG",
                ],
              },
              {
                "@type": "EmploymentAgency",
                "@id": "https://alnjoom.sa/#agency",
                name: "مكتب النجوم المميزة للاستقدام في تبوك",
                url: "https://alnjoom.sa/",
                mainEntityOfPage: {
                  "@id": "https://alnjoom.sa/#webpage",
                },
                parentOrganization: {
                  "@id": "https://alnjoom.sa/#organization",
                },
                description:
                  "مكتب النجوم المميزة للاستقدام هو مكتب استقدام معتمد  في تبوك يقدم خدمات استقدام العمالة المنزلية من الفلبين وكينيا وإثيوبيا وبنجلاديش وباكستان وبوروندي لجميع مناطق المملكة العربية السعودية.",
                image: {
                  "@type": "ImageObject",
                  url: "https://alnojoom.ejjadh.info/uploads/file-1712543546576.png",
                },
                telephone: "+966594003605",
                address: {
                  "@type": "PostalAddress",
                  streetAddress: "King Fahd Rd, Assulimaniyah",
                  addressLocality: "Tabuk",
                  addressRegion: "Tabuk",
                  postalCode: "47312",
                  addressCountry: "SA",
                },
                geo: {
                  "@type": "GeoCoordinates",
                  latitude: 28.403638,
                  longitude: 36.569611,
                },
                hasMap: "https://maps.app.goo.gl/hJf3ho1R44bsZBd29",
                openingHoursSpecification: [
                  {
                    "@type": "OpeningHoursSpecification",
                    dayOfWeek: [
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                    ],
                    opens: "09:00",
                    closes: "12:00",
                  },
                  {
                    "@type": "OpeningHoursSpecification",
                    dayOfWeek: [
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                    ],
                    opens: "16:00",
                    closes: "22:00",
                  },
                  {
                    "@type": "OpeningHoursSpecification",
                    dayOfWeek: "Saturday",
                    opens: "16:00",
                    closes: "22:00",
                  },
                ],
                areaServed: {
                  "@type": "Country",
                  name: "Saudi Arabia",
                },
                priceRange: "SAR 3950-14499",
                currenciesAccepted: "SAR",
                paymentAccepted: ["Visa", "MasterCard", "Mada"],
                contactPoint: {
                  "@id": "https://alnjoom.sa/#contact",
                },
                aggregateRating: {
                  "@type": "AggregateRating",
                  ratingValue: "4.4",
                  reviewCount: "247",
                  bestRating: "5",
                  worstRating: "1",
                },
                knowsAbout: [
                  "استقدام العمالة المنزلية",
                  "استقدام من الفلبين",
                  "استقدام من كينيا",
                  "استقدام من إثيوبيا",
                  "استقدام من بنجلاديش",
                  "استقدام من باكستان",
                  "استقدام من بوروندي",
                  "منصة مساند",
                ],
              },
              {
                "@type": "WebSite",
                "@id": "https://alnjoom.sa/#website",
                url: "https://alnjoom.sa/",
                name: "مكتب النجوم المميزة للاستقدام",
                publisher: {
                  "@id": "https://alnjoom.sa/#organization",
                },
                inLanguage: ["ar-SA", "en-SA"],
              },
              {
                "@type": "WebPage",
                "@id": "https://alnjoom.sa/#webpage",
                url: "https://alnjoom.sa/",
                name: "مكتب النجوم المميزة للاستقدام",
                isPartOf: {
                  "@id": "https://alnjoom.sa/#website",
                },
                about: {
                  "@id": "https://alnjoom.sa/#agency",
                },
                mainEntity: {
                  "@id": "https://alnjoom.sa/#agency",
                },
                inLanguage: "ar-SA",
              },
              {
                "@type": "Service",
                "@id": "https://alnjoom.sa/#service",
                name: " خدمات استقدام العمالة المنزلية في تبوك",
                serviceType: "استقدام العمالة المنزلية",
                provider: {
                  "@id": "https://alnjoom.sa/#agency",
                },
                areaServed: {
                  "@type": "Country",
                  name: "Saudi Arabia",
                },
              },
            ],
          }),
        }}
      />

      <HeroSection heroData={heroData} siteInfo={siteInfo} />
      <About siteInfo={siteInfo} data={aboutData} />
      <RequirementsSection siteInfo={siteInfo} data={requirementsData} />
      <Systems siteInfo={siteInfo} data={systemsData} />
      <Countries data={countriesData} personnel={personnelsData} />

      <div className={`contact-page ${styles.contact}`}>
        <Row>
          <h3 className="contact-header unique-bold">
            <FormattedMessage id="communicate" />
          </h3>
        </Row>
        <div className="contact-page-top wrapper">
          <Row>
            <div className="contact-row-wrapper p-0">
              <Row className="contact-row">
                <Col xs="12" md="6" className="align-self-center">
                  <Form
                    formTitle={<FormattedMessage id="service_question" />}
                    formSubtitle={<FormattedMessage id="service_ask" />}
                  />
                </Col>

                <Col xs="12" md="6">
                  <div
                    className="contact-page-map"
                    data-aos="fade-up"
                    data-aos-duration="300"
                    data-aos-delay="400"
                    dangerouslySetInnerHTML={{
                      __html: initData?.siteInfo?.mapframe ?? "",
                    }}
                  ></div>
                </Col>
              </Row>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};

export async function getServerSideProps(ctx) {
  const redirect = await checkRedirect(ctx.resolvedUrl, ctx.req);
  if (redirect) return { redirect };

  try {
    const [
      homeResponse,
      systemsResponse,
      countriesResponse,
      personnelsResponse,
      projectsResponse,
      categoriesResponse,
      seoPageResponse,
    ] = await Promise.all([
      server.get("/pages/home"),
      server.get("/pages/systems"),
      server.get("/countries"),
      server.get("/personnels"),
      server.get("/pages/projects"),
      server.get("/pages/categories"),
      server.get("/pages/seo-data"),
    ]);

    const sectionData = (r) => r?.data?.data?.page?.sections || [];
    const homeData = (section) =>
      sectionData(homeResponse)?.filter((e) => e?.slug == section)?.[0] || [];

    const seoData = sectionData(seoPageResponse)?.find(
      (section) => section?.pageName === "home",
    );

    return {
      props: {
        heroData: {
          ...homeData("intro"),
          background: homeData("intro")?.backgroundImage || "",
        },
        systemsData: {
          heading: homeData("systems")?.heading || "",
          description: homeData("systems")?.description || "",
          items: sectionData(systemsResponse)?.slice(0, 4),
        },
        aboutData: {
          ...homeData("about"),
        },
        countriesData: {
          heading: homeData("countries")?.heading || "",
          description: "",
          items: countriesResponse?.data?.data?.countries,
        },
        categoriesData: {
          ...(homeData("categories") || {}),
          items: sectionData(categoriesResponse)?.map((cat) => ({
            ...cat,
            projectsLength:
              sectionData(projectsResponse)?.filter(
                (p) => p?.category?.slug == cat?.slug,
              )?.length || "",
          })),
        },
        personnelsData: {
          items: personnelsResponse?.data?.data?.personnels,
        },
        requirementsData: {
          ...homeData("requirements"),
        },
        seoData,
      },
    };
  } catch (error) {
    console.log("error", error);
    return {
      props: {
        error: JSON.stringify(error),
      },
    };
  }
}

export default Index;
